import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { IControlAreasByPointResponseDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";

export class GetControlAreasByPointCommand
    extends IRequestCommand<
    IControlAreasByPointResponseDTO,
    ErrorDetails,
    IGetControlAreasByPointRequest
    > {
    override _commandType: CommandRequestType = CommandRequestType.POST;

    public override setParameters(parameters: IGetControlAreasByPointRequest) {
        this._commandBody = parameters;
        this.urlSections.push('carriers');
        this.urlSections.push(`${parameters.carrierId}`);
        this.urlSections.push('carrierArea');
        this.urlSections.push('controlAreas');
        this.composeUrl();
    }
}

export interface IGetControlAreasByPointRequest extends ICommandParameters {
    carrierId: number;
    latitude: number;
    longitude: number;
}

export { IControlAreasByPointResponseDTO };

